<template>
  <div id='topbar'>
    <div class='top-nav1'>
      <!-- logo -->
      <div class='top-logo'>
        <img class="headImg" src="../../assets/headImg.png" />
        <span>农业云门户</span>
      </div>
      <!-- 搜索框-->

      <div class="searchBox">
        <el-input v-model="inputValue" placeholder="请输入内容" class="headInput"></el-input>
        <img src="../../assets/headSearch.png" @click="search" class="headSearch">
      </div>
      <!--登录/登录头像-->

    </div>

    <div class='top-nav2' :class='{ "shrinkNav": $route.meta.pickUpNav }'>
      <el-menu :default-active='activeIndex' class='el-menu-demo' mode='horizontal' background-color='#005431'
        text-color='#fff' active-text-color='#FFFFFF' router @select="handlerMenuSelect">
        <el-menu-item index='/recommend'>首页</el-menu-item>
        <el-menu-item index='/toplist'>企业风采</el-menu-item>
        <el-menu-item index='/playlist'>农业新闻</el-menu-item>
        <el-menu-item index='/singer'>政策法规</el-menu-item>
        <el-menu-item index='/djradio'>科技推广</el-menu-item>
        <el-menu-item index='/qualitysafe'>质量安全</el-menu-item>
      </el-menu>
    </div>
    <div>
      
    </div>
    <div class="menuBox">
      <div class="menuDetail">
        <div class="menuTitle" @click="goHome">首页</div>
      <div class="flex" @click="showMenu">
        <img src="../../assets/operation.png" class="operationImg">
      </div>
      </div>

    </div>
    <div v-if="$route.meta.title!='农业云门户' && $route.meta.title!='搜索'" class="pcBox">
      <div class="pcTitle">
        <span class="ml10">您当前所在的位置是：首页><span v-if="$route.meta.title =='绿色动态详情'">农业新闻></span><span v-if="$route.meta.title =='政策法规详情'">政策法规></span>{{$route.meta.title}}</span>
      </div>
    </div>
    <div v-if="$route.meta.title!='农业云门户' && $route.meta.title!='搜索'" class="mobileBox">
      <div class="mobileTitle">
        <span class="ml10">首页><span v-if="$route.meta.title =='绿色动态详情'">农业新闻></span><span v-if="$route.meta.title =='政策法规详情'">政策法规></span>{{$route.meta.title}}</span>

      </div>
    </div>
    <el-drawer
  :visible.sync="drawer"
  :with-header="false"
  size="30"
  direction="rtl"
  :before-close="handleClose">
  <div  :class='{ "shrinkNav": $route.meta.pickUpNav }'>
      <el-menu :default-active='activeIndex' class='el-menu-demo' mode='vertical' background-color='#005431'
        text-color='#fff' active-text-color='#FFFFFF' router @select="handlerMenuSelectMobile">
        <el-menu-item index='/recommend'>首页</el-menu-item>
        <el-menu-item index='/toplist'>企业风采</el-menu-item>
        <el-menu-item index='/playlist'>农业新闻</el-menu-item>
        <el-menu-item index='/singer'>政策法规</el-menu-item>
        <el-menu-item index='/djradio'>科技推广</el-menu-item>
      </el-menu>
    </div>
</el-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'Topbar',
  data() {
    return {
      drawer: false,
      inputValue:'',
      dialogFormVisible: false, //控制显示登录dialog
      activeIndex: sessionStorage.getItem("topMenuIndex") || '/recommend',
      searchVal: '',
      sub: sessionStorage.getItem('curTopbarNav') || 1,
    }
  },
  created() {
  },
  methods: {
    goHome(){
      this.$router.push({path:'/recommend'})
      this.handlerMenuSelectMobile("/recommend")
    },
    search(){
      if(!this.inputValue){
        this.$message.error('请输入你要搜索的内容');
        return
      }
      this.$router.push({path:'/searchIndex',query: { keywords: this.inputValue }})
    },
    handleClose(done){
      done();
    },
    showMenu(){
      this.drawer = true;
    },
    routerTo(path, sub) {
      // 路由跳转并更改小三角sub显示
      window.sessionStorage.setItem('curTopbarNav', sub)
      this.sub = sub
      this.$router.push(path)
    },
    handlerMenuSelectMobile(index) {
      this.activeIndex = index;
      window.sessionStorage.setItem("topMenuIndex", index);
      this.drawer = false;
    },
    handlerMenuSelect(index) {
      this.activeIndex = index;
      window.sessionStorage.setItem("topMenuIndex", index);
    },
    async querySearch(queryString, cb) {
      let ts = Date.now();
      let result = await this.$API.searchSuggest(queryString, ts);
      if (result.data.code === 200) {
        let arr = this.formatSearchResult(result.data.result);
        cb(arr);
      }
    },
    // 格式化搜索结果
    formatSearchResult(result) {
      let arr = [];
      return arr;
    },
    // 选择搜索结果后跳转到对应页面
    handleSearchSelect() {

    },

    logout() {
      this.$store.dispatch('userLogout');
    }
  },
  computed: {
    ...mapState(['isLogin']),
    ...mapGetters(['userAvatarUrl']),
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-menu-item {
  border-bottom: none !important;
  width: 200px !important;
  text-align: center;
}

::v-deep .el-menu-item.is-active {
  background: #077044 !important;
  border-bottom: none !important;
  width: 200px !important;
  text-align: center;
}

::v-deep .el-menu {
  border-bottom: none !important;
}
//移动端
@media (max-width: 768px) {
  .top-nav1 {
    height: 140px;
    width: 100%;
    padding-top: 30px;
  }
  .mobileBox{
    width: 100%;
    display: flex;
    height: 50px;
    align-items: center;

font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
    
  }
  .mobileTitle{
    padding: 0 15px;
  }
.pcBox{
  display: none;
}
  .flex{
    display: flex;
  }
  .menuTitle{
font-weight: 800;
font-size: 16px;
color: #FFFFFF;
text-align: left;
font-style: normal;
text-transform: none;
  }
  .menuDetail{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
  }
  .menuBox{
    background: #005431;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .operationImg{
    width: 25px;
    height: 25px;
  }
.top-nav2{
  display: none !important;
}


  .headImg {
    width: 50px;
    height: 50px;
    margin-right: 8px;
  }

  .top-logo {
    font-weight: 800;
    font-size: 30px;
    display: flex;
    justify-content: center;

  }
  .searchBox{
  display: flex;
  justify-content: center;
  margin: 30px auto;

}
}
//pc端
@media (min-width: 769px) {
  .ml10{
    margin-left: 15px;
  }
  .top-nav1 {
    height: 140px;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    ul {
      display: flex;
      flex-flow: row nowrap;
      height: 100%;

      li {
        margin: 0 20px 0 0;
        width: 100px;
        height: 100%;
        color: #ccc;
        text-align: center;
        cursor: pointer;

        a {
          position: relative;

          span {
            line-height: 70px;
          }

          .cor {
            width: 12px;
            height: 6px;
            position: absolute;
            top: 38px;
            left: 50%;
          }
        }
      }

      li:hover {
        color: white;
        background-color: #000000;
      }
    }

    .login {
      margin-left: 20px;
      color: #606266;

      img {
        vertical-align: middle;
        border-radius: 50%;
        width: 30px;
        height: 30px;
      }
    }
  }
  .mobileBox{
    display: none;
  }
.pcBox{
width: 100%;
background: #f5f5f5;
}
.pcTitle{
  width: 1200px;
height: 50px;
background: #FFFFFF;
border-radius: 0px 0px 0px 0px;
display: flex;
align-items: center;
font-weight: 500;
font-size: 16px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
margin: 0 auto;
}
  .menuBox{
    display: none;
  }
#topbar {
  justify-content: center;
  align-items: center;
}
  .headImg {
    width: 90px;
    height: 80px;
    margin-right: 8px;
  }

  .top-logo {
    font-size: 28px;
    margin-right: 25px;
    display: flex;
    align-items: center;
    font-weight: 800;
    font-size: 40px;
    color: #231815;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

}
.searchBox{
  display: flex;
  align-items: center;
  width: 328px;
}
.headSearch{
  width: 30px;
  height: 31px;
  margin-left: -40px;
  z-index: 699;
}
::v-deep .el-input__inner{
  height: 100%;
}
.headInput{
    height: 50px;
  }
.top-logo{
  display: flex;
  align-items: center;
}


#topbar {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-flow: column;




  .top-nav2 {
    width: 100%;
    display: flex;
    flex-flow: nowrap;
    justify-content: center;
    background-color: #005431;

  }

  .shrinkNav {
    height: 5px;
    overflow: hidden;
  }
}

.my-autocomplete {
  li {

    .searchSuggest {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      justify-content: start;


      .type {
        font-size: 12px;
        color: #b4b4b4;
        border-right: 1px #e6e6e6 solid;
        padding-right: 10px;
      }

      .data {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        border-top: 1px solid #e6e6e6;

        p {
          padding-left: 5px;
          display: block;
        }

        p:hover {
          background-color: #cacaca;
        }
      }
    }

  }
}
</style>
